<template>
  <v-app :style="style">
    <v-app-bar app dense clipped-left clipped-right> 
        <v-toolbar-title>3D to 2D Animations</v-toolbar-title>
        <v-subheader class="pa-0 ma-0 pl-1">v{{ version }}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn @click="basicInstructionsStep = 0; isBasicInstructionsOpen = true;">
            Basic Instructions
        </v-btn>
        <a style="text-decoration: none;" target="_blank" rel="noopener noreferrer" href="https://3dto2danimations.com/learn.html" title="">
            <v-btn>
                Tutorials
            </v-btn>
        </a>
        <!--<v-divider vertical></v-divider>
        <a style="text-decoration: none;" target="_blank" rel="noopener noreferrer" href="https://3dto2danimations.com/index.html" title="">
            <v-btn>
                Showcase
            </v-btn>
        </a> -->
        <a style="text-decoration: none;" target="_blank" rel="noopener noreferrer" href="https://discord.gg/EMBce39jzX" title="">
            <v-btn>
                <v-icon>mdi-discord</v-icon>
            </v-btn>
        </a>
        <a style="text-decoration: none;" target="_blank" rel="noopener noreferrer" href="https://twitter.com/3Dto2DAnim" title="">
            <v-btn>
                <v-icon>mdi-twitter</v-icon>
                @3Dto2DAnim
            </v-btn>
        </a>
    </v-app-bar>
    <div @transitionend="transitionEnd" class="full-height" @dragleave="onDropStopHover" @dragover="onDropHover" id="dropzone">
      <v-navigation-drawer style="direction: rtl;" permanent :width="menuWidth" app clipped disable-resize-watcher>
        <div style="direction: ltr;">
        <EffectsMenu>
        </EffectsMenu>
        <PostProcessingMenu>
        </PostProcessingMenu>
        <LightsMenu>
        </LightsMenu>
        </div>
      </v-navigation-drawer>
      <v-navigation-drawer :width="menuWidth" permanent app clipped right disable-resize-watcher>
        <TransformMenu>
        </TransformMenu>
        <DisplayMenu>
        </DisplayMenu>
        <!--<MaterialsMenu>
        </MaterialsMenu> -->
        <CaptureMenu @setAnimationTime="setAnimationTime" :projectName="folderName" :animations=this.currentAnimationsNames :currentAnimationDuration=this.currentAnimationDuration :renderer=this.renderer>
        </CaptureMenu>
      </v-navigation-drawer>
      <v-main id="main" class="full-height">
        <v-container class="pa-0 ma-0 full-height">
          <div class="full-height" id="renderer">
          </div>
        </v-container>
      </v-main>
      <v-overlay absolute opacity=0.0 z-index=3 :value="isShowDropZone">
        <v-card rounded outlined>
          <v-container fill-height>
            <v-row class="justify-center">
              <v-card-title class="text-md-h4 pb-0 mb-0 justify-center">
                  Drag a glTF 2.0 folder here
              </v-card-title>
            </v-row>
            <v-row class="justify-center">
              <v-card-subtitle class="text-md-subtitle-1 pt-0 mt-0 justify-center">
                  To start your journey!
              </v-card-subtitle>
            </v-row>
            <v-row class="justify-center">
              <v-card-actions class="justify-center">
                <v-btn @click="onClickLoadButton" color="primary">
                    Load Model
                </v-btn>
                <input ref="fileInput" style="display: none;" type="file" id="file-input" webkitdirectory multiple>
              </v-card-actions>
            </v-row>
            <v-row class="justify-center">
              <v-card-actions class="justify-center">
                <v-btn @click="onClickLoadExampleButton" color="error">
                    Load an Example Model Instead
                </v-btn>
              </v-card-actions>
            </v-row>
          </v-container>
          <v-fade-transition>
            <v-overlay v-if="isShowDropColor" absolute color="#3f80e880">
            </v-overlay>
          </v-fade-transition>
        </v-card>
      </v-overlay>
    </div>
      <v-overlay v-if="isScreenTooSmall" color="#ffffff" absolute opacity=1.0 z-index=12>
        <div class="msg-container">
            <div class="title-container">
                <img class="logo-img" src="/assets/img/icon_medium.ico">
                <h1 class="page-title">
                    3D to 2D<br>Animations
                </h1>
            </div>
            <h1 class="page-text">
                Your screen is too small to use this tool
            </h1>
            <h1 class="page-text">
                Try to zoom out or use a bigger screen
            </h1>
            <a href="https://3dto2danimations.com/learn.html">
            <button class="learn-more">
                Or watch a showcase instead!
            </button>
            </a>
        </div>
      </v-overlay>

     <v-dialog v-model="isBasicInstructionsOpen" width="70%">
      <v-card outlined>
        <v-card-title>
            How to use the tool (:
        </v-card-title>
        <v-card-text style="font-size: 20px">
            {{ basicInstructions[basicInstructionsStep].text }}
        </v-card-text>

        <v-divider></v-divider>
          <v-carousel height="auto" v-model="basicInstructionsStep">
            <v-carousel-item 
              v-for="(item,i) in basicInstructions"
              :key="i" :src="item.src">
            </v-carousel-item>
          </v-carousel>
      </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import Vuex from 'vuex';
import { SimpleDropzone } from 'simple-dropzone';
import { Scene,
         PerspectiveCamera,
         WebGLRenderer,
         sRGBEncoding,
         LinearEncoding,
         HemisphereLight,
         AmbientLight,
         DirectionalLight,
         PMREMGenerator,
         //Group,
         //Points,
         //UnsignedByteType,
         Box3,
         Vector2,
         Vector3,
         Vector4,
         Matrix4,
         DoubleSide,
         SkeletonHelper,
         GridHelper,
         AxesHelper,
         LoaderUtils,
         LoadingManager,
         DataTexture,
         RGBFormat,
         MeshNormalMaterial,
         Color,
         DirectionalLightHelper,
         //BoxHelper,
         //Box3Helper,
         //Mesh,
         //InstancedMesh,
         SkinnedMesh,
         //AdditiveBlending,
        //MeshBasicMaterial,
         AnimationMixer } from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
//import { OBJLoader } from  'three/examples/jsm/loaders/OBJLoader.js'
//import { FBXLoader } from  'three/examples/jsm/loaders/FBXLoader.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
//import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
//import { RenderPass } from  'three/examples/jsm/postprocessing/RenderPass.js';
//import { GlitchPass } from  'three/examples/jsm/postprocessing/GlitchPass.js';
import { ShaderPass } from  'three/examples/jsm/postprocessing/ShaderPass.js';
//import { PixelShader } from 'three/examples/jsm/shaders/PixelShader.js';
import { HighlightCaptureShader } from './shaders/HighlightCaptureShader.js';

import PostProcessingMenu from './components/PostProcessingMenu';
import CaptureMenu from './components/CaptureMenu';
import DisplayMenu from './components/DisplayMenu.vue';
import LightsMenu from './components/LightsMenu.vue';
import TransformMenu from './components/TransformMenu.vue';
//import MaterialsMenu from './components/MaterialsMenu.vue';
import EffectsMenu from './components/EffectsMenu.vue';
import { EffectRenderPass } from './shaders/EffectRenderPass.js';
import { AvailableEffects } from './shaders/AvailableEffects.js';
import { HexToRGBA } from 'vuetify/lib/util/colorUtils.js'
import { AvailableMaterials } from './shaders/AvailableMaterials.js'
//import ModelLoader from './shaders/ModelLoader.js'

export default {
  name: 'App',
  components: {
    PostProcessingMenu,
    CaptureMenu,
    DisplayMenu,
    LightsMenu,
    TransformMenu,
    //MaterialsMenu,
    EffectsMenu,
  },
  data: function () {
      return { 
               style: {},
               version: "0.8",
               currentAnimations: [], 
               currentAnimationsNames: [], 
               currentAnimationDuration: 0,
               isAnimationPlaying: true,
               renderer: null,
               isShowDropColor: false,
               isShowDropZone: true,
               folderName: "",
               isBasicInstructionsOpen: false,
               basicInstructionsStep: 0,
               basicInstructions: [ { text: "Drag a folder containing a gltf model to load the model", src: "/assets/img/basic_instructions/step1.png"},
                                    { text: "Use the capture menu to select the desired animation to render. Set the number of frames you'd like. Use the controls to play and stop the animation frames.", src: "/assets/img/basic_instructions/step2.png"},
                                    { text: "Use the post processing menu to add effects to the render. Drag the numbers to quickly change the effects settings.", src: "/assets/img/basic_instructions/step3.png"},
                                    { text: "Set the desired output width and height and click 'Capture Animation' to render", src: "/assets/img/basic_instructions/step4.png"},
                                    { text: "Press 'Download Images' to download the results. Have fun (:", src: "/assets/img/basic_instructions/step5.png"},
               ],
             };
  },
  mounted() {
      this.initFirebase();
      this.initDropzone();
      this.initThreeJs();

      this.$nextTick(() => {
        // Code that will run only after the
        // entire view has been rendered
        this.onWindowResize();
      });

      this.isBasicInstructionsOpen = !this.isScreenTooSmall;
  },
  methods: {
      initFirebase() {
          try {
              if (window["firebase"] !== undefined && typeof window.firebase !== undefined) {
                 window.firebase.analytics();
              } else {
                  console.log("Couldn't initalize firebase analytics");
              }
          } catch(err) {
              console.log("Couldn't initalize firebase analytics");
          }
      },
      transitionEnd(e) {
          if (e.propertyName == "width" || e.propertyName == "padding-left" || e.propertyName == "padding-right") {
              //var source = e.target || e.srcElement;
              //console.log(source);
              //console.log(e.propertyName);

              this.$vuetify.application.left = parseInt(this.menuWidth);
              this.$vuetify.application.right = parseInt(this.menuWidth);

              this.$nextTick(() => {
                // Code that will run only after the
                // entire view has been rendered
                this.onWindowResize();
              });
          }
      },
      updateCanvasZoom() {
          console.log("Canvas Zoom:", this.canvasZoom);
          this.onWindowResize();
          //this.renderer.setSize(this.contentMain.offsetWidth / this.canvasZoom, this.contentMain.offsetHeight / this.canvasZoom, false);
      },
      onDropHover() {
          this.isShowDropColor = true;
      },
      onDropStopHover() {
          this.isShowDropColor = false;
      },
      initDropzone() {
          var dropEl = document.querySelector("#dropzone");
          var inputEl = document.querySelector("#file-input");
          this.dropControl = new SimpleDropzone(dropEl, inputEl);
          this.dropControl.on("drop", ({files}) => {
                //console.log("DROP EVENT");
                this.loadModel(files);
                var filename = files.keys().next().value;
                //console.log(files);
                filename = filename.slice(1);
                filename = filename.slice(0, filename.indexOf("/"));
                //console.log("AAAAAAAAAAAAA", filename);
                this.folderName = filename;
                this.isShowDropZone = false;
                //this.$store.commit('setCurrentModelPath', filename);
                //this.$store.commit('setCurrentModelPath', './assets/models/phoenix/scene.gltf');
          });

          inputEl.removeEventListener('change', this.dropControl._onSelect);
          inputEl.addEventListener('change', () => {
              this.dropControl._emit('dropstart');

              // HTML file inputs do not seem to support folders, so assume this is a flat file list.
              const files = [].slice.call(this.dropControl.inputEl.files);

              // Automatically decompress a zip archive if it is the only file given.
              if (files.length === 1 && this.dropControl._isZip(files[0])) {
                this.dropControl._loadZip(files[0]);
                return;
              }

              const fileMap = new Map();
              //files.forEach((file) => fileMap.set(file.name, file));
              files.forEach((file) => fileMap.set(file.webkitRelativePath, file));
              this.dropControl._emit('drop', {files: fileMap});
          });
      },
      initThreeJs() {
          this.currentLoadedScene = null;
          //this.currentAnimations = ["AA"];
          this.previousTime = 0;
          this.currentAnimationAction = null;

          this.scene = new Scene();
          //this.scene.background = new Color(0x0);
          //this.scene.background = new Color(0xffffff);

          this.contentMain = document.getElementById("main");

          this.camera = new PerspectiveCamera( 60, this.contentMain.offsetWidth / this.contentMain.offsetHeight, 0.01, 1000);

          this.renderer = new WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true});
          this.renderer.physicallyCorrectLights = true;
          this.renderer.outputEncoding = sRGBEncoding;
          this.renderer.setPixelRatio( window.devicePixelRatio );


          //console.log(this.renderer);
          this.renderer.setSize(this.contentMain.offsetWidth, this.contentMain.offsetHeight);
          //this.renderer.setSize(window.innerWidth, window.innerHeight);
          this.renderer.toneMappingExposure = 1.0;
          //this.renderer.sortObjects = false;

          document.getElementById('renderer').appendChild(this.renderer.domElement);

          this.effectComposer = new EffectComposer(this.renderer);

          this.effectRenderPass = new EffectRenderPass(this.scene, this.camera);
          this.effectComposer.addPass(this.effectRenderPass);

          this.currentPostProcessingShaders = [];
          //this.pixelPass = new ShaderPass(PixelShader);
          //this.effectComposer.addPass(this.pixelPass);

          this.highlightCapturePass = new ShaderPass(HighlightCaptureShader);
          this.effectComposer.addPass(this.highlightCapturePass);

          //this.glitchPass = new GlitchPass();
          //this.effectComposer.addPass(this.glitchPass);
          
          this.controls = new OrbitControls(this.camera, this.renderer.domElement);
          this.camera.position.set( 0, 20, 100 );
          this.controls.update();

          this.hemisphereLight = new HemisphereLight();
          this.hemisphereLight.position.set( 0, 0, -100);
          this.scene.add( this.hemisphereLight );

          this.ambientLight = new AmbientLight(0xffffff, 2.3);
          //this.camera.add(this.ambientLight);
          this.scene.add(this.ambientLight);

          this.directionalLight = new DirectionalLight(0xffffff, 4.5);
          //this.directionalLight.position.set(0.5, 0.0, 0.866);
          this.scene.add(this.directionalLight);
          //this.camera.add(this.directionalLight);

          this.directionalLightHelper = new DirectionalLightHelper(this.directionalLight, 5);
          //this.scene.add(this.directionalLightHelper);

          this.isLightsAdded = true;

          //this.loadWhiteEnvironment();
          //Trying some promises here
          this.loadEnvironment().then(( { environmentMap }) => {
              this.environmentMap = environmentMap;
              this.scene.environment = this.environmentMap;
              //this.scene.background = this.environmentMap;

          });

          requestAnimationFrame((time) => this.render(time));

          window.addEventListener('resize', () => this.onWindowResize(), false);
          this.skeletonHelpers = [];
          this.gridHelper = null;
          this.axesHelper = null;

          this.effects = {};
          for (let i = 0; i < AvailableEffects.length; i++) {
              this.effects[AvailableEffects[i].title] = AvailableEffects[i].constructor(this.renderer);
          }

          this.sceneSize = 10;
      },

      loadWhiteEnvironment() {
          var width = 32;
          var height = 32;
          var size = width * height;

          var data = new Uint8Array(3 * size);
          for (let i = 0; i < size; i++) {
              let stride = i * 3;
              data[stride] = 255;
              data[stride + 1] = 255;
              data[stride + 2] = 255;
          }

          var texture = new DataTexture(data, width, height, RGBFormat);
          this.environmentMap = texture;
          this.scene.environment = this.environmentMap;
      },
      onWindowResize() {
          //console.log("Window Resize Called!!", e);
          document.getElementById('renderer').removeChild(this.renderer.domElement);

          let paddingLeft = parseInt(this.contentMain.style.paddingLeft);
          let paddingRight = parseInt(this.contentMain.style.paddingRight);
          let paddingHeight = parseInt(this.contentMain.style.paddingTop);

          //let rect = this.contentMain.getBoundingClientRect();
          let width = this.contentMain.clientWidth - paddingLeft - paddingRight;
          let height = this.contentMain.clientHeight - paddingHeight;
          //let height = window.innerHeight;

          //console.log("Resize width, height", width, height);
          //let width = rect.width;
          //let height = rect.height;

          //console.log(width, height);
          //this.camera.aspect = window.innerWidth / window.innerHeight;
          this.camera.aspect = width / height;
          this.camera.updateProjectionMatrix();


          //console.log("Canvas zoom: ", this.canvasZoom);
          this.renderer.setSize(width, height);
          document.getElementById('renderer').appendChild(this.renderer.domElement);
          this.renderer.setSize(width / this.canvasZoom, height / this.canvasZoom, false);

          //this.renderer.setSize(this.contentMain.offsetWidth / this.canvasZoom, this.contentMain.offsetHeight / this.canvasZoom, false);
          //this.renderer.setSize(window.innerWidth, window.innerHeight);
      },

      onClickLoadButton() {
          this.$refs.fileInput.click();
      },

      onClickLoadExampleButton() {
          var filename = "./assets/models/death/scene.gltf";
          this.loadModel(filename);
      },

      loadModel(filesMap) {
          this.clearModel();

          //this.modelLoader = new ModelLoader();
          //var result = this.modelLoader.loadFromFiles(filesMap);
          //if (result) {
          //    result.then((gltf) => {
          //        console.log(gltf);
          //        this.setCurrentModel(gltf);
          //    });
          //} else {
          //    console.log("Model loading failed...");
          //}

          if (typeof filesMap === 'string') {
              var objLoader = new GLTFLoader();
              var filePath = filesMap;
              this.isShowDropZone = false;
              var filename = filesMap;
              filename = filename.slice(0, filename.lastIndexOf("/"));
              filename = filename.slice(filename.lastIndexOf("/") + 1);
              this.folderName = filename;
              return objLoader.load(filePath,
                            (obj) => {
                                this.setCurrentModel(obj);
                            },
                            function(xhr) {
                                console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
                            },
                            function(error) {
                                console.log("error loading object", error);
                            });
            }

          let rootFile;
          let rootPath;

          Array.from(filesMap).forEach(([path, file]) => {
            if (file.name.match(/\.(gltf|glb)$/)) {
              rootFile = file;
              rootPath = path.replace(file.name, '');
            }
          });

          const fileURL = typeof rootFile === 'string'
            ? rootFile
            : URL.createObjectURL(rootFile);

          var url = fileURL;
          var assetMap = filesMap;

          //TODO: ADD CLEAR THE CANVAS?
          const baseURL = LoaderUtils.extractUrlBase(url);

          // Load.
          return new Promise((resolve, reject) => {

            const manager = new LoadingManager();

            // Intercept and override relative URLs.
            manager.setURLModifier((url, path) => {

              // URIs in a glTF file may be escaped, or not. Assume that assetMap is
              // from an un-escaped source, and decode all URIs before lookups.
              // See: https://github.com/donmccurdy/three-gltf-viewer/issues/146
              const normalizedURL = rootPath + decodeURI(url)
                .replace(baseURL, '')
                .replace(/^(\.?\/)/, '');

              if (assetMap.has(normalizedURL)) {
                const blob = assetMap.get(normalizedURL);
                const blobURL = URL.createObjectURL(blob);
                blobURLs.push(blobURL);
                return blobURL;
              }

              return (path || '') + url;

            });

            const loader = new GLTFLoader(manager);
            loader.setCrossOrigin('anonymous');

            const dracoLoader = new DRACOLoader();
            dracoLoader.setDecoderPath( 'assets/draco/' );
            loader.setDRACOLoader( dracoLoader );

            const blobURLs = [];

            loader.load(url, (gltf) => {

              const scene = gltf.scene || gltf.scenes[0];
              //const clips = gltf.animations || [];

              if (!scene) {
                // Valid, but not supported by this viewer.
                throw new Error(
                  'This model contains no scene, and cannot be viewed here. However,'
                  + ' it may contain individual 3D resources.'
                );
              }

              //console.log(gltf);
              this.setCurrentModel(gltf);

              blobURLs.forEach(URL.revokeObjectURL);

              // See: https://github.com/google/draco/issues/349
              // DRACOLoader.releaseDecoderModule();

              resolve(gltf);

            }, undefined, reject);

          });
      },

      loadEnvironment() {
          var width = 512;
          var height = 512;
          var size = width * height;

          var data = new Uint8Array(3 * size);
          for (let i = 0; i < size; i++) {
              let stride = i * 3;
              data[stride] = 255;
              data[stride + 1] = 255;
              data[stride + 2] = 255;
          }

          var texture = new DataTexture(data, width, height, RGBFormat);

          var pmremGenerator = new PMREMGenerator(this.renderer);
          pmremGenerator.compileEquirectangularShader();

          return new Promise( (resolve) => {
                      const environmentMap = pmremGenerator.fromEquirectangular(texture).texture;
                      pmremGenerator.dispose();
                      resolve( { environmentMap } );
          });

          //const path = "./assets/environments/venice_sunset_1k.hdr";


          //return new Promise( (resolve, reject) => {
          //    new RGBELoader()
          //        .setDataType(UnsignedByteType)
          //        .load(path, (texture) => {
          //            const environmentMap = pmremGenerator.fromEquirectangular(texture).texture;
          //            pmremGenerator.dispose();
          //            resolve( { environmentMap } );
          //    }, undefined, reject);
          //});
      },

      updateSkeleton() {
            //console.log("Updating Skeleton : ", this.isShowSkeleton);
            if (this.skeletonHelpers.length) {
                this.skeletonHelpers.forEach((helper) => this.scene.remove(helper));
            }

            this.skeletonHelpers = [];
            if (!this.currentLoadedScene) {
                return;
            }
            if (this.isShowSkeleton) {
                this.currentLoadedScene.traverse((node) => {
                    if (node.isMesh && node.skeleton) {
                        const helper = new SkeletonHelper(node.skeleton.bones[0].parent);
                        helper.material.lineWidth = 3;
                        this.scene.add(helper);
                        this.skeletonHelpers.push(helper);
                    }
                });
            }
      },
      updateWireframe() {
            //console.log("Updating Wireframe : ", this.isShowWireframe);
            if (!this.currentLoadedScene) {
                return;
            }
            this.traverseMaterials(this.currentLoadedScene, (material) => {
                material.wireframe = this.isShowWireframe;
            });
      },
      updateGrid() {
            //console.log("Updating Grid: ", this.isShowGrid);
            if (this.isShowGrid) {
                this.gridHelper = new GridHelper(this.sceneSize);
                this.axesHelper = new AxesHelper(this.sceneSize/2);
                this.axesHelper.renderOrder = 999;
                this.axesHelper.onBeforeRender = (renderer) => renderer.clearDepth();
                this.scene.add(this.gridHelper);
                this.scene.add(this.axesHelper);
            } else {
                this.scene.remove(this.gridHelper);
                this.scene.remove(this.axesHelper);
                this.gridHelper = null;
                this.axesHelper = null;
            }
      },
      updateNormals() {
          if (!this.currentLoadedScene) {
              return;
          }
          //console.log("Updating Normals");
          if (this.isShowNormals) {
              this.changeToNormalsMaterials();
              this.scene.background = new Color(0x8080ff);
          } else {
              this.changeToOriginalMaterials();
              this.scene.background = null;
          }
      },

      traverseMaterials(parent_node, callback) {
        parent_node.traverse((node) => {
            if (!node.isMesh) {
                return;
            }
            const materials = Array.isArray(node.material)
            ? node.material
            : [node.material];

            materials.forEach(callback);
        });
      },
      traverseChangeMaterials(parent_node, callback) {
        parent_node.traverse((node) => {
            if (!node.isMesh) {
                return;
            }
            const materials = Array.isArray(node.material)
            ? node.material
            : [node.material];

            //console.log("Material on this node: ", materials.length);
            for (let i = 0; i < materials.length; i++) {
                node.material = callback(materials[i]);
            }
            //materials.forEach(callback);
        });
      },
      addPostProcessingShader() {
      },

      clearModel() {
          if (!this.currentLoadedScene) {
              return;
          }
          this.scene.remove(this.currentLoadedScene);

          this.currentLoadedScene.traverse((node) => {
              if (!node.isMesh) {
                  return;
              }
              node.geometry.dispose();
          });

          // glTF texture types. `envMap` is deliberately omitted, as it's used internally
          // by the loader but not part of the glTF format.
          const MAP_NAMES = [
            'map',
            'aoMap',
            'emissiveMap',
            'glossinessMap',
            'metalnessMap',
            'normalMap',
            'roughnessMap',
            'specularMap',
          ];

          this.traverseMaterials(this.currentLoadedScene, (material) => {
              MAP_NAMES.forEach( (map) => {
                  if (material[ map ]) {
                      material[ map ].dispose();
                  }
              });
          });

          this.originalMaterials.forEach((material) => material.dispose());
          this.normalsMaterials.forEach((material) => material.dispose());

          this.originalMaterials = null;
          this.normalsMaterials = null;
          this.currentLoadedScene = null;
      },

      //More information about this:
      //https://discourse.threejs.org/t/object-bounds-not-updated-with-animation/3749/12
      getSkinnedMeshBoundingBox(skinnedMesh) {
          var vertex = new Vector3();
          var temp = new Vector3();
          var skinned = new Vector3();
          var skinIndices = new Vector4();
          var skinWeights = new Vector4();
          var boneMatrix = new Matrix4();

          var skeleton = skinnedMesh.skeleton;
          //skeleton.update();
          var boneMatrices = skeleton.boneMatrices;
          var geometry = skinnedMesh.geometry;

          var index = geometry.index;
          var position = geometry.attributes.position;
          var skinIndex = geometry.attributes.skinIndex;
          var skinWeigth = geometry.attributes.skinWeight;

          var bindMatrix = skinnedMesh.bindMatrix;
          var bindMatrixInverse = skinnedMesh.bindMatrixInverse;

          var i, j, si, sw;

          var aabb = new Box3();

          aabb.makeEmpty();

          //console.log("Attributes: ", temp, index, position, skinIndex, skinWeigth);
          if ( index !== null ) {
              // indexed geometry
              for ( i = 0; i < index.count; i ++ ) {
                  let currentIndex = index.array[i];
                  //console.log("Index Sama: ", currentIndex);
                  vertex.fromBufferAttribute( position, currentIndex);
                  skinIndices.fromBufferAttribute( skinIndex, currentIndex);
                  skinWeights.fromBufferAttribute( skinWeigth, currentIndex);

                  // the following code section is normally implemented in the vertex shader
                  vertex.applyMatrix4( bindMatrix ); // transform to bind space
                  skinned.set( 0, 0, 0 );

                  //console.log("Before expand by?", skinned, vertex, skinIndices, skinWeights);
                  for ( j = 0; j < 4; j ++ ) {
                      si = skinIndices.getComponent( j );
                      sw = skinWeights.getComponent( j );
                      //console.log(si, sw, boneMatrices.slice(si*16, (si+1)*16));
                      boneMatrix.fromArray( boneMatrices, si * 16 );

                      // weighted vertex transformation
                      temp.copy( vertex ).applyMatrix4( boneMatrix ).multiplyScalar( sw );

                      //console.log(...boneMatrix.elements);
                      //console.log("Before expand by? temp", skinned, temp, vertex, si, sw, boneMatrices, boneMatrix);
                      skinned.add( temp );
                  }
                  skinned.applyMatrix4( bindMatrixInverse ); // back to local space
                  // expand aabb
                  //console.log("Expand by?", skinned);
                  aabb.expandByPoint( skinned );
              }
          } else {
              // non-indexed geometry
              for ( i = 0; i < position.count; i ++ ) {
                  vertex.fromBufferAttribute( position, i );
                  skinIndices.fromBufferAttribute( skinIndex, i );
                  skinWeights.fromBufferAttribute( skinWeigth, i );

                  // the following code section is normally implemented in the vertex shader

                  vertex.applyMatrix4( bindMatrix ); // transform to bind space
                  skinned.set( 0, 0, 0 );

                  for ( j = 0; j < 4; j ++ ) {
                      si = skinIndices.getComponent( j );
                      sw = skinWeights.getComponent( j );
                      boneMatrix.fromArray( boneMatrices, si * 16 );

                      // weighted vertex transformation
                      temp.copy( vertex ).applyMatrix4( boneMatrix ).multiplyScalar( sw );
                      skinned.add( temp );

                  }
                  skinned.applyMatrix4( bindMatrixInverse ); // back to local space
                  // expand aabb
                  //console.log("Expand by?1", skinned);
                  aabb.expandByPoint( skinned );
              }
          }
          aabb.applyMatrix4( skinnedMesh.matrixWorld );

          return aabb;
      },

      setCurrentModel: async function(obj) {
          const scene = obj.scene || obj.scenes[0];

          this.scene.add(scene);

          const animations = obj.animations || [];

          this.currentLoadedScene = scene;

          //We must render before we calculate the model position
          this.effectComposer.render();

          var sceneSize = null;
          var sceneCenter = null;
          var lastSize = 0;
          var biggestSkinnedMesh = null;
          scene.traverse((o) => {
              //Disable culling altogether
              o.frustumCulled = false;

              //Find the biggest skinned mesh
              if (o instanceof SkinnedMesh) {
                  let tmpBox = new Box3().setFromObject(o);
                  let boxSize = tmpBox.getSize(new Vector3()).length();
                  if (boxSize > lastSize) {
                      lastSize = boxSize;
                      biggestSkinnedMesh = o;
                  }
              }
          });

          if (biggestSkinnedMesh != null) {
              var finalBoundingBox = this.getSkinnedMeshBoundingBox(biggestSkinnedMesh);
              sceneSize = finalBoundingBox.getSize(new Vector3()).length();
              sceneCenter = finalBoundingBox.getCenter(new Vector3());
          } else {
              let box = new Box3().setFromObject(scene);
              sceneSize = box.getSize(new Vector3()).length();
              sceneCenter = box.getCenter(new Vector3());
          }
          this.sceneSize = sceneSize;
              
          scene.position.x += (scene.position.x - sceneCenter.x);
          scene.position.y += (scene.position.y - sceneCenter.y);
          scene.position.z += (scene.position.z - sceneCenter.z);

          this.controls.reset();
          this.controls.maxDistance = sceneSize * 10;
          this.camera.near = sceneSize / 100;
          this.camera.far = sceneSize * 1000;

          this.camera.updateProjectionMatrix();

          this.camera.position.copy(sceneCenter);
          this.camera.position.x += sceneSize / 2.0;
          this.camera.position.y += sceneSize / 5.0;
          this.camera.position.z += sceneSize / 2.0;

          this.camera.lookAt(sceneCenter);

          this.directionalLight.position.copy(sceneCenter);
          this.directionalLight.position.y += sceneSize / 5.0;

          this.scene.remove(this.directionalLightHelper);

          this.directionalLightHelper = new DirectionalLightHelper(this.directionalLight, sceneSize/2);
          if (this.lightSettings.isShowDirectionalLight) {
              this.scene.add(this.directionalLightHelper);
          } 

          let value = { x: this.directionalLight.position.x.toFixed(2),
                        y: this.directionalLight.position.y.toFixed(2),
                        z: this.directionalLight.position.z.toFixed(2) };

          this.$store.commit('setDirectLightPosition', value);

          //this.scene.add(scene);

          scene.traverse((node) => {
            if (node.isLight) {
              //this.state.addLights = false;
            } else if (node.isMesh) {
              // TODO(https://github.com/mrdoob/three.js/pull/18235): Clean up.
              //node.material.envMap = this.environmentMap;
              //node.material.side = DoubleSide;
              //node.material.alphaTest = 0.5;
              node.material.depthWrite = true;
              //node.material.depthWrite = !node.material.transparent;
            }
          });

          this.animationMixer = new AnimationMixer(this.currentLoadedScene);

          this.currentAnimations = animations;
          this.currentAnimationsNames = animations.map((animation) => animation.name);
          this.currentAnimationsNames.unshift("No Animation");
          if (this.currentAnimationsNames.length > 1) {
              this.$store.commit('setCurrentAnimationName', this.currentAnimationsNames[1]);
          } else {
              this.$store.commit('setCurrentAnimationName', "No Animation");
          }

          this.originalMaterials = [];
          this.normalsMaterials = [];

          this.traverseMaterials(this.currentLoadedScene, (material) => {
              this.originalMaterials.push(material);
              let displacementMap = material.displacementMap;
              let normalMap = material.normalMap;
              var normalMaterial = new MeshNormalMaterial( {
                displacementMap: displacementMap,
                //displacementScale: SCALE,
                //displacementBias: BIAS,

                normalMap: normalMap,
                //normalScale: new Vector2( 1, - 1 ),

                //flatShading: true,

                skinning: true,
                side: DoubleSide,
              });

              this.normalsMaterials.push(normalMaterial);
              //return normalMaterial;
          });
          //let clip = animations[0];
          //this.currentAnimationAction = this.animationMixer.clipAction(clip);
          //this.currentAnimationAction.stop();
          //this.currentAnimationAction.reset();
          //this.currentAnimationAction.play();

          const sleepTimeToRender = m => new Promise(r => setTimeout(r, m))
          var sleepTime = 100;
          if (this.$store.state.isShowGrid) {
              this.$store.commit("setIsShowGrid", false);
              await sleepTimeToRender(sleepTime);
              this.$store.commit("setIsShowGrid", true);
          }
      },

      changeToOriginalMaterials() {
          this.traverseChangeMaterials(this.currentLoadedScene, (material) => {
              var materialIndex = this.normalsMaterials.indexOf(material);
              if (materialIndex == -1) {
                  console.log("ERROR: material index not found???");
                  return material;
              }
              return this.originalMaterials[materialIndex];
          });
      },
      changeToNormalsMaterials() {
          this.traverseChangeMaterials(this.currentLoadedScene, (material) => {
              var materialIndex = this.originalMaterials.indexOf(material);
              if (materialIndex == -1) {
                  console.log("ERROR: material index not found???");
                  return material;
              }
              return this.normalsMaterials[materialIndex];
          });
      },
      changeAnimation() {
          this.isAnimationPlaying = true;
          var animationName = this.currentAnimationName;
          if (this.currentAnimationAction) {
              this.currentAnimationAction.stop();
              this.currentAnimationAction.reset();
          }
          this.currentAnimationAction = null;
          let clip = this.currentAnimations.find(element => element.name == animationName);
          if (clip) {
              this.currentAnimationDuration = clip.duration;
              this.currentAnimationAction = this.animationMixer.clipAction(clip);
              this.currentAnimationAction.stop();
              this.currentAnimationAction.reset();
              this.currentAnimationAction.play();
          }
      },

      setAnimationTime(animationTime) {
          this.isAnimationPlaying = false;
          if (this.currentAnimationAction) {
              //this.currentAnimationAction.stop();
              //this.currentAnimationAction.reset();
              this.animationMixer.setTime(animationTime);
          }
      },

      render(time) {
          requestAnimationFrame((time) => this.render(time));

          const dt = (time - this.previousTime) / 1000;
          this.previousTime = time;

          this.controls.update();
          if (this.animationMixer && this.isAnimationPlaying) {
              this.animationMixer.update(dt);
          }

          this.updateShadersUniforms(time);
          //this.outlineEffect.render(this.scene, this.camera);

          this.effectComposer.render();

          //this.renderer.render(this.scene, this.camera);
      },

      updateShadersUniforms(time) {
          this.highlightCapturePass.uniforms['canvasSize'].value.x = this.renderer.domElement.width;
          this.highlightCapturePass.uniforms['canvasSize'].value.y = this.renderer.domElement.height;
          this.highlightCapturePass.uniforms['captureSize'].value.x = this.$store.state.captureWidth;
          this.highlightCapturePass.uniforms['captureSize'].value.y = this.$store.state.captureHeight;
          this.highlightCapturePass.uniforms['isCaptureVisible'].value = this.$store.state.isCaptureVisible;

          for (let i = 0; i < this.currentPostProcessingShaders.length; i++) {
              if ('resolution' in this.currentPostProcessingShaders[i].uniforms) {
                  if (!this.currentPostProcessingShaders[i].uniforms['resolution'].value) {
                      this.currentPostProcessingShaders[i].uniforms['resolution'].value = new Vector2();
                  }
                  this.currentPostProcessingShaders[i].uniforms['resolution'].value.x = this.renderer.domElement.width;
                  this.currentPostProcessingShaders[i].uniforms['resolution'].value.y = this.renderer.domElement.height;
              }
              if ('time' in this.currentPostProcessingShaders[i].uniforms) {
                  this.currentPostProcessingShaders[i].uniforms['time'].value += time;
              }
              if ('uDirLightPos' in this.currentPostProcessingShaders[i].uniforms) {
                  this.currentPostProcessingShaders[i].uniforms['uDirLightPos'].value.copy(this.directionalLight.position);
              }

              for (var uniform in this.postProcessingShaders[i].uniforms) {
                  if (this.currentPostProcessingShaders[i].uniforms[uniform]) {
                      //console.log("update uniforms", this.postProcessingShaders[i].uniforms[uniform].value);
                      this.currentPostProcessingShaders[i].uniforms[uniform].value = this.postProcessingShaders[i].uniforms[uniform].value;
                  }
              }
          }
          //this.pixelPass.uniforms['resolution'].value = new Vector2(this.renderer.domElement.width, this.renderer.domElement.height);
          //this.pixelPass.uniforms['pixelSize'].value = 5;
      },

      updatePostProcessingShaders() {
          //console.log("Updating Post Processing Shaders!!!");
          this.effectComposer = new EffectComposer(this.renderer);
          this.effectComposer.addPass(this.effectRenderPass);

          this.currentPostProcessingShaders = []

          if (!this.isShowNormals) {
              for (let i = 0; i < this.postProcessingShaders.length; i++) {
                  let newShader = new ShaderPass(this.postProcessingShaders[i].type);
                  this.currentPostProcessingShaders.push(newShader);

                  if (!this.postProcessingShaders[i].properties.isEnabled) {
                      continue;
                  }

                  if (this.isPostProcessingEnabled) {
                      this.effectComposer.addPass(newShader);
                  }
                  //console.log(newShader.uniforms);
              }
          }
          //this.pixelPass = new ShaderPass(PixelShader);
          //this.effectComposer.addPass(this.pixelPass);

          //this.highlightCapturePass = new ShaderPass(HighlightCaptureShader);
          this.effectComposer.addPass(this.highlightCapturePass);
          //console.log(this.effectComposer);
      },

      updateLights() {
          //console.log("updateLights");

          if (this.lightSettings.isLightsEnabled && !this.isLightsAdded) {
              //console.log("Adding Lights");
              this.isLightsAdded = true;
              this.scene.add(this.ambientLight);
              this.scene.add(this.directionalLight);

          } else if (!this.lightSettings.isLightsEnabled && this.isLightsAdded) {
              //console.log("Removing Lights");
              this.isLightsAdded = false;
              this.scene.remove(this.ambientLight);
              this.scene.remove(this.directionalLight);
          }

          this.ambientLight.intensity = this.lightSettings.ambientIntensity;
          this.ambientLight.color.set(this.lightSettings.ambientColor);
          this.directionalLight.intensity = this.lightSettings.directIntensity;
          this.directionalLight.color.set(this.lightSettings.directColor);

          if (this.lightSettings.outputEncoding === "sRGB") {
              this.renderer.outputEncoding = sRGBEncoding;
          } else if (this.lightSettings.outputEncoding === "Linear") {
              this.renderer.outputEncoding = LinearEncoding;
          }

          const encoding = this.lightSettings.textureEncoding === 'sRGB'
            ? sRGBEncoding
            : LinearEncoding;

          if (!this.currentLoadedScene) {
              return;
          }

          this.renderer.toneMappingExposure = this.lightSettings.toneMappingExposure;

          if (this.lightSettings.isEnvironmentEnabled) {
              this.scene.environment = this.environmentMap;
          } else {
              this.scene.environment = null;
          }

          this.traverseMaterials(this.currentLoadedScene, (material) => {
              if (material.map) {
                  material.map.encoding = encoding;
              }
              if (material.emissiveMap) {
                  material.emissiveMap.encoding = encoding;
              }
              if (material.map || material.emissiveMap) {
                  material.needsUpdate = true;
              }
          });

          this.directionalLight.position.x = this.lightSettings.directLightPosition.x;
          this.directionalLight.position.y = this.lightSettings.directLightPosition.y;
          this.directionalLight.position.z = this.lightSettings.directLightPosition.z;

          this.directionalLight.rotation.x = this.lightSettings.directLightRotation.x;
          this.directionalLight.rotation.y = this.lightSettings.directLightRotation.y;
          this.directionalLight.rotation.z = this.lightSettings.directLightRotation.z;

          this.scene.remove(this.directionalLightHelper);
          if (this.lightSettings.isShowDirectionalLight) {
              this.scene.add(this.directionalLightHelper);
          } 
      },
      updateTransform() {
          if (!this.currentLoadedScene) {
              return;
          }

          let scaleSettings = this.transformSettings.scaleSettings;
          //console.log("Updating Scale: ", scaleSettings.x, scaleSettings.y, scaleSettings.z);
          this.currentLoadedScene.scale.x = scaleSettings.x;
          this.currentLoadedScene.scale.y = scaleSettings.y;
          this.currentLoadedScene.scale.z = scaleSettings.z;

          let rotationSettings = this.transformSettings.rotationSettings;
          this.currentLoadedScene.rotation.x = rotationSettings.x;
          this.currentLoadedScene.rotation.y = rotationSettings.y;
          this.currentLoadedScene.rotation.z = rotationSettings.z;
      },
      updateEffect() {
          //console.log("Updating Effect:", this.currentEffect);
          if (this.currentEffect == "No Effect") {
              this.effectRenderPass.setRenderEffect(null);
          } else {
              //console.log(this.effects[this.currentEffect]);
              this.effectRenderPass.setRenderEffect(this.effects[this.currentEffect]);
          }
      },
      updateAntiAlias() {
          return;
          //////console.log("isAntiAlias: ", this.isAntiAlias);
          //////create the new renderer

          ////document.getElementById('renderer').removeChild(this.renderer.domElement);
          ////this.renderer = new WebGLRenderer({ antialias: this.isAntiAlias, alpha: true, preserveDrawingBuffer: true});
          ////this.renderer.physicallyCorrectLights = true;
          ////this.renderer.outputEncoding = sRGBEncoding;
          ////this.renderer.setPixelRatio( window.devicePixelRatio );

          //////console.log(this.renderer);
          ////this.renderer.setSize(this.contentMain.offsetWidth, this.contentMain.offsetHeight);
          //////this.renderer.setSize(window.innerWidth, window.innerHeight);
          ////this.renderer.toneMappingExposure = 1.0;
          //////this.renderer.sortObjects = false;

          ////document.getElementById('renderer').appendChild(this.renderer.domElement);

          ////this.loadEnvironment().then(( { environmentMap }) => {
          ////    this.environmentMap = environmentMap;
          ////    this.scene.environment = this.environmentMap;
          ////    //this.scene.background = this.environmentMap;

          ////});

          ////this.controls.domElement = this.renderer.domElement;
          ////this.controls = new OrbitControls(this.camera, this.renderer.domElement);
          ////////this.camera.position.set( 0, 20, 100 );
          ////this.controls.update();

          ////this.updateLights();
          ////this.updateCanvasZoom();
          ////this.updatePostProcessingShaders();
          //////console.log(this.renderer);
      },
      updateEffectSettings() {
          if (!this.currentLoadedScene) {
              return;
          }

          //Hack - I'm sorry, I'm tired
          //Currently (and it seems like in the future) the only effect is the outline effect
          if (this.currentEffect == "Outline Effect") {
              this.traverseMaterials(this.currentLoadedScene, (material) => {
                      let settings = {...this.effectSettings};
                      let c = HexToRGBA(settings.color);
                      settings["color"] = [c.r/255.0, c.g/255.0, c.b/255.0];
                      material.userData.outlineParameters = settings;
              });
          }
      },
      updateBackgroundColor() {
          this.style = { backgroundColor: this.backgroundColor };
          //this.$vuetify.theme.themes.dark.background = this.backgroundColor;
      },
      updateCurrentMaterial() {
          if (!this.currentLoadedScene) {
              return;
          }

          var found = AvailableMaterials.find((elm) => {
              return elm.title == this.currentMaterial;
          });

          //console.log(found);
          //var newMaterial = new MeshBasicMaterial({ color: 0xffaa00, transparent: true, blending: AdditiveBlending })
          //var newMaterial = new found.type()
          this.traverseChangeMaterials(this.currentLoadedScene, (oldMaterial) => {
              var newMaterial = new found.type();
              //let gradMap = newMaterial.gradientMap;
              //let alphaMap = newMaterial.alphaMap;
              this.copyMaterials(newMaterial, oldMaterial);
              //newMaterial.gradientMap = gradMap;
              //newMaterial.alphaMap = alphaMap;
              if (!oldMaterial.map) {
                  newMaterial.color = oldMaterial.color;
              } else {
                  newMaterial.map = oldMaterial.map;
              }
              return newMaterial;
          });
      },
        copyMaterials: function ( dest, source ) {

        dest.name = source.name;

        dest.fog = source.fog;

        dest.blending = source.blending;
        dest.side = source.side;
        dest.flatShading = source.flatShading;
        dest.vertexColors = source.vertexColors;

        dest.opacity = source.opacity;
        dest.transparent = source.transparent;

        dest.blendSrc = source.blendSrc;
        dest.blendDst = source.blendDst;
        dest.blendEquation = source.blendEquation;
        dest.blendSrcAlpha = source.blendSrcAlpha;
        dest.blendDstAlpha = source.blendDstAlpha;
        dest.blendEquationAlpha = source.blendEquationAlpha;

        dest.depthFunc = source.depthFunc;
        dest.depthTest = source.depthTest;
        dest.depthWrite = source.depthWrite;

        dest.stencilWriteMask = source.stencilWriteMask;
        dest.stencilFunc = source.stencilFunc;
        dest.stencilRef = source.stencilRef;
        dest.stencilFuncMask = source.stencilFuncMask;
        dest.stencilFail = source.stencilFail;
        dest.stencilZFail = source.stencilZFail;
        dest.stencilZPass = source.stencilZPass;
        dest.stencilWrite = source.stencilWrite;

        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;

        if ( srcPlanes !== null ) {

            const n = srcPlanes.length;
            dstPlanes = new Array( n );

            for ( let i = 0; i !== n; ++ i ) {

                dstPlanes[ i ] = srcPlanes[ i ].clone();

            }

        }

        dest.clippingPlanes = dstPlanes;
        dest.clipIntersection = source.clipIntersection;
        dest.clipShadows = source.clipShadows;

        dest.shadowSide = source.shadowSide;

        dest.colorWrite = source.colorWrite;

        dest.precision = source.precision;

        dest.polygonOffset = source.polygonOffset;
        dest.polygonOffsetFactor = source.polygonOffsetFactor;
        dest.polygonOffsetUnits = source.polygonOffsetUnits;

        dest.dithering = source.dithering;

        dest.alphaTest = source.alphaTest;
        dest.premultipliedAlpha = source.premultipliedAlpha;

        dest.visible = source.visible;

        dest.toneMapped = source.toneMapped;

        dest.userData = JSON.parse( JSON.stringify( source.userData ) );

        return dest;

    },
  },
  
  computed: {
      isScreenTooSmall() {
          var result = false;
          switch (this.$vuetify.breakpoint.name) {
                case 'xs': 
                  result = true;
                  break;
                case 'sm':
                  result = true;
                  break;
                case 'md':
                  result = false;
                  break;
                case 'lg':
                  result = false;
                  break;
                case 'xl':
                  result = false;
                  break;
          }

          return result;
      },
      menuWidth() {
          let size = "300px";
          switch (this.$vuetify.breakpoint.name) {
                case 'xs': 
                  size = '0';
                  break;
                case 'sm':
                  size = '0';
                  break;
                case 'md':
                  size = '250px';
                  break;
                case 'lg':
                  size = '350px';
                  break;
                case 'xl':
                  size = '400px';
                  break;
          }

          //console.log("Current Breakpoint: " + this.$vuetify.breakpoint.name + " size: " + size);

          //Hack from the land of the hacks
          //setTimeout(() => {
          //    this.$vuetify.application.left = parseInt(size);
          //    this.$vuetify.application.right = parseInt(size);
          //}, 200);

          return size;
      },
      ...Vuex.mapState([
          //'currentModelPath',
          'currentAnimationName',
          'postProcessingShaders',
          'isShowSkeleton',
          'isShowWireframe',
          'isShowGrid',
          'isShowNormals',
          'isAntiAlias',
          'canvasZoom',
          'lightSettings',
          'transformSettings',
          'currentEffect',
          'effectSettings',
          'currentMaterial',
          'backgroundColor',
          'isPostProcessingEnabled',
      ]),
  },

  watch: {
      isScreenTooSmall() {
          if (this.isScreenTooSmall && this.isBasicInstructionsOpen) {
            this.isBasicInstructionsOpen = false;
          } 
      },
      //currentModelPath() {
      //    this.loadModel();
      //},
      currentAnimationName() {
          this.changeAnimation();
      },
      postProcessingShaders() {
          this.updatePostProcessingShaders();
      },
      isShowSkeleton() {
          this.updateSkeleton();
      },
      isShowWireframe() {
          this.updateWireframe();
      },
      isShowGrid() {
          this.updateGrid();
      },
      isShowNormals() {
          this.updateNormals();
          this.updatePostProcessingShaders();
      },
      canvasZoom() {
          this.updateCanvasZoom();
      },
      lightSettings() {
          this.updateLights();
      },
      transformSettings() {
          this.updateTransform();
      },
      currentEffect() {
          this.updateEffect();
      },
      effectSettings() {
          this.updateEffectSettings();
      },
      currentMaterial() {
          this.updateCurrentMaterial();
      },
      isAntiAlias() {
          //this.updateAntiAlias();
      },
      backgroundColor() {
          this.updateBackgroundColor();
      },
      isPostProcessingEnabled() {
          this.updatePostProcessingShaders();
      },
  },
}
</script>

<style>
html { 
    overflow-y: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

.full-height {
    height: 100%;
}

/* Scrollbar */
div.v-navigation-drawer__content {
    scrollbar-width: thin;
}

/* width */
::-webkit-scrollbar {
    width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #00000000; 
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #606060; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #909090; 
}

@font-face {
    font-family: dpcomic;
    src: url("/assets/fonts/dpcomic.ttf");
}

.logo-img {
    min-width: 64px;
    width: 64px;
}

.msg-container {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-items: center;
    min-height: 100vh;
    text-align: center;
}

h1.page-title {
    font-family: dpcomic;
    font-size: 36px;
    text-shadow: 3px 3px #fdcde4;
    color: #000000;
}

.title-container {
    display: flex;
    flex-flow: row;
    align-items: center;
    font-family: dpcomic;
    line-height: initial;
}

button.learn-more {
    margin-bottom: 60px;
    color: #382b22;
    text-transform: uppercase;
    padding: 0.75em 1em;
    background: #fff0f0;
    border: 2px solid #b18597;
    border-radius: 0.75em;
    position: relative;
    display: inline-block;
    cursor: pointer;
    outline: none;
    vertical-align: middle;
    text-decoration: none;
    font-size: 30px;
    font-family: dpcomic;
    font-weight: 300;
    appearance: button;
    -webkit-writing-mode: horizontal-tb !important;
    text-rendering: auto;
    color: -internal-light-dark(black, white);
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: center;
    align-items: flex-start;
    cursor: default;
    background-color: -internal-light-dark(rgb(239, 239, 239), rgb(59, 59, 59));
    box-sizing: border-box;
    margin: 0em;
    border-width: 2px;
    border-style: outset;
    border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
    border-image: initial;
    box-sizing: border-box;
    transform-style: preserve-3d;
    transition: transform 150ms cubic-bezier(0, 0, 0.58, 1), background 150ms cubic-bezier(0, 0, 0.58, 1);
    margin: 20px;
    margin-top: 0px;
}

button.learn-more:hover {
    background: #ffe9e9;
    -webkit-transform: translate(0, 0.25em);
    transform: translate(0, 0.25em);
}

button.learn-more::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f9c4d2;
    border-radius: inherit;
    box-shadow: 0 0 0 2px #b18597, 0 0.625em 0 0 #ffe3e2;
    transform: translate3d(0, 0.75em, -1em);
    transition: transform 150ms cubic-bezier(0, 0, 0.58, 1), box-shadow 150ms cubic-bezier(0, 0, 0.58, 1);
}

button.learn-more:hover::before {
    box-shadow: 0 0 0 2px #b18597, 0 0.5em 0 0 #ffe3e2;
    -webkit-transform: translate3d(0, 0.5em, -1em);
    transform: translate3d(0, 0.5em, -1em);
}

button.learn-more:active { 
    background: #ffe9e9; 
    transform: translate(0em, 0.75em); 
}

button.learn-more:active::before { 
    box-shadow: 0 0 0 2px #b18597, 0 0 #ffe3e2; 
    transform: translate3d(0, 0, -1em); 
}

h1.page-text {
    font-family: dpcomic;
    font-size: 36px;
    text-shadow: 3px 3px #fdcde4;
    color: #000000;
    margin: 20px;
}

</style>
